import { render, staticRenderFns } from "./temporary-password-reset.vue?vue&type=template&id=8c897ab8"
import script from "./temporary-password-reset.vue?vue&type=script&lang=js"
export * from "./temporary-password-reset.vue?vue&type=script&lang=js"
import style0 from "./temporary-password-reset.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/temporary-password-reset/temporary-password-reset.vue
// module id = +PSr
// module chunks = 0